import { useRef } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import SectionTitle from '@/components/feature/SectionTitle';

export default function TrendingSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const hotArticles = articles.filter((a) => a.isHot).slice(0, 8);

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = dir === 'left' ? -320 : 320;
      scrollRef.current.scrollBy({ left: amount, behavior: 'smooth' });
    }
  };

  return (
    <section className="bg-foreground-950 py-12 md:py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between mb-8">
          <div className="flex items-center gap-3">
            <span className="px-3 py-1 border border-background-400 text-background-300 text-xs rounded-full">
              实时更新
            </span>
            <SectionTitle title="24H 热门爆料" subtitle="TRENDING" light align="left" />
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 rounded-full border border-background-700 text-background-400 hover:text-background-200 hover:border-background-500 flex items-center justify-center transition-colors"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-line" />
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 rounded-full border border-background-700 text-background-400 hover:text-background-200 hover:border-background-500 flex items-center justify-center transition-colors"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-line" />
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 overflow-x-auto pb-4 snap-x snap-mandatory scrollbar-hide"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {hotArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group flex-shrink-0 w-64 sm:w-72 snap-start"
            >
              <div className="bg-background-100 rounded-xl overflow-hidden">
                <div className="relative aspect-square overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                  {article.isExclusive && (
                    <span className="absolute top-2 left-2 px-2 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-md">
                      独家
                    </span>
                  )}
                </div>
                <div className="p-3 bg-foreground-950">
                  <h3 className="text-sm font-semibold text-background-50 line-clamp-2 mb-1 group-hover:text-primary-300 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-xs text-background-400">{article.publishDate}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}